import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import HomeScreen from './screens/HomeScreen';
import EmployeeScreen from './screens/EmployeeScreen';
import AnotherPage from './screens/AnotherPage';

function App() {
     return (
          <BrowserRouter>
               <div className="App">
                    <h1>Navigator</h1>
                    <main>
                         <Routes>
                              <Route path="/" element={<HomeScreen />} />
                              <Route path="/employee/:slug" element={<EmployeeScreen />} />
                              <Route path="/anotherpage" element={<AnotherPage />} />
                         </Routes>
                    </main>
               </div>
          </BrowserRouter>
     );
}

export default App;
